'use strict';

define(
    'BetSlipWindowDir',[],function () {
        function BetSlipWindowDir($window, $timeout) {
            return {
                restrict: 'E',
                templateUrl: 'js/modules/BetSlipWindow/templates/betslip-window.html',
                controller: 'BetSlipWindowCtrl',
                scope: true,
                link: function ($scope) {
                    $scope.$watch('data.selectedBetType', function () {
                        $timeout(function() {
                            var newSize = parseInt(($scope.data.cols.length * 50) + 350);
                            newSize = newSize < 535 ? 535 : newSize;
                            $window.resizeBy( newSize - $window.outerWidth,0);
                        }, 100);
                    });

                    angular.element(document.querySelectorAll("layout")[0]).css({
                        'width': '100%',
                        'min-width': 0,
                        'height': '100%',
                        'margin': '0 auto',
                        'position': 'absolute'
                    });
                }
            };
        }

        BetSlipWindowDir.$inject = [
            '$window',
            '$timeout'
        ];
        return BetSlipWindowDir;
    }
);

